import React from "react";

import { IActiveFacet } from "types";
import { i18nService } from "services";

import { ActiveFacet } from "./ActiveFacet";

interface ActiveFacetsProps {
  activeFacets: IActiveFacet[];
  clearAllFacets: () => void;
}

export const ActiveFacets: React.FC<ActiveFacetsProps> = ({
  activeFacets,
  clearAllFacets,
}) => (
  <div className="facets__active active-facets">
    <h2 className="form-label">{i18nService.copy["facets.selectedFacets"]}</h2>
    <ul className="active-facets__list">
      {activeFacets.map((activeFacet) => (
        <li className="active-facets__item" key={activeFacet.label}>
          <ActiveFacet activeFacet={activeFacet} />
        </li>
      ))}
    </ul>
    <button
      className="active-facets__remove"
      type="button"
      onClick={clearAllFacets}
    >
      {i18nService.copy["facets.removeAllFacets"]}
    </button>
  </div>
);
